import { render } from "./History.vue?vue&type=template&id=2dc04be9"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=2dc04be9&lang=css"

import exportComponent from "C:\\Users\\mathe\\Desktop\\matheogirard.fr\\front-pi_air-v2.matheogirard.fr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__